import React from 'react';
import {FormattedMessage} from 'react-intl';

export default class FormSelectableField extends React.Component {
    static propTypes = {
        field: React.PropTypes.object.isRequired,
        message: React.PropTypes.object.isRequired,
        options: React.PropTypes.array.isRequired,
        required: React.PropTypes.bool
    };

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    render() {
        const {message, field, options, required, disabled} = this.props;

        const notRequiredLabelClass = 'login--form__label form__label';
        const requiredLabelClass = 'login--form__label form__label form__label__required';
        const inputClass = 'login--form__control form__control';
        const rowClass = 'form__row';

        const labelClass = required ? requiredLabelClass : notRequiredLabelClass;

        return (
            <div className={rowClass}>
                <label className={labelClass}>
                    <FormattedMessage {...message}/>
                </label>
                <select className={inputClass} {...field} disabled={disabled}>
                    {options}
                </select>
                {field.touched && field.error && FormSelectableField.renderHint(field.error)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/FormSelectableField.jsx